<template>
    <div class="gas-info-card">
        <b-card no-body class="overflow-hidden shadow border-0 main-card">
            <div class="card-header-custom">
                <div class="header-content">
                    <i class="fa fa-check-circle header-icon"></i>
                    <h2 class="mb-0">Gases Inflamables</h2>
                </div>
            </div>

            <b-row no-gutters>
                <b-col md="8">
                    <b-card-body class="content-section">
                        <div class="info-section">
                            <div class="info-row">
                                <div class="info-label">Clase:</div>
                                <div class="info-value">
                                    <span class="text-uppercase fw-bold">Gases Inflamables</span>
                                </div>
                            </div>

                            <div class="info-row">
                                <div class="info-label">Estado de clasificación:</div>
                                <div class="info-value">
                                    <span class="not-classified-badge">No clasificado</span>
                                </div>
                            </div>

                            <div class="classification-notice">
                                <i class="fa fa-info-circle notice-icon"></i>
                                <p class="notice-text">NO SE CUMPLEN LOS CRITERIOS DE CLASIFICACIÓN DEL SGA, PARA ESTA CLASE DE PELIGRO</p>
                            </div>
                        </div>
                    </b-card-body>
                </b-col>

                <b-col md="4" class="pictogram-column">
                    <div class="pictogram-container">
                        <div class="pictogram-wrapper not-classified">
                            <i class="fa fa-ban not-classified-icon"></i>
                        </div>
                        <div class="pictogram-label">
                            <span>NO APLICABLE</span>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <div class="card-footer-custom">
                <i class="fa fa-info-circle mr-2"></i>
                <span>Esta sustancia ha sido evaluada y no cumple con los criterios para clasificarse en esta categoría de peligro.</span>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'GasInformationCardNotClassified'
}
</script>

<style scoped>
.gas-info-card {
    max-width: 900px;
    margin: 2rem auto;
    font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}

.card-header-custom {
    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
    color: white;
    padding: 1.5rem;
}

.header-content {
    display: flex;
    align-items: center;
}

.header-icon {
    font-size: 2rem;
    margin-right: 1rem;
}

.content-section {
    padding: 1.5rem;
}

.info-section {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
}

.info-row {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 1rem;
}

.info-label {
    font-weight: 600;
    color: #555;
    margin-bottom: 0.4rem;
}

.info-value {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.not-classified-badge {
    background-color: #6c757d;
    color: white;
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    font-weight: bold;
    font-size: 0.9rem;
}

.classification-notice {
    background-color: #f8f9fa;
    border-left: 4px solid #4b6cb7;
    padding: 1rem;
    margin-top: 1rem;
    display: flex;
    align-items: flex-start;
    border-radius: 4px;
}

.notice-icon {
    color: #4b6cb7;
    font-size: 1.2rem;
    margin-right: 0.8rem;
    margin-top: 0.2rem;
}

.notice-text {
    margin: 0;
    font-weight: 500;
    color: #333;
}

.pictogram-column {
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    display: flex;
    align-items: center;
    justify-content: center;
}

.pictogram-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    width: 100%;
}

.pictogram-wrapper {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    margin-bottom: 1rem;
}

.pictogram-wrapper.not-classified {
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6;
}

.not-classified-icon {
    font-size: 5rem;
    color: #adb5bd;
}

.pictogram-label {
    color: #666;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 1px;
}

.card-footer-custom {
    background-color: #f8f8f8;
    color: #555;
    padding: 1rem 1.5rem;
    font-size: 0.9rem;
    border-top: 1px solid #eaeaea;
}

@media (max-width: 767.98px) {
    .info-row {
        flex-direction: column;
    }

    .info-label {
        margin-bottom: 0.5rem;
    }

    .pictogram-wrapper {
        width: 120px;
        height: 120px;
    }

    .not-classified-icon {
        font-size: 4rem;
    }
}
</style>
